"use strict";
//
// Copyright © 2024 Hardcore Engineering Inc.
//
// Licensed under the Eclipse Public License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License. You may
// obtain a copy of the License at https://www.eclipse.org/legal/epl-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//
// See the License for the specific language governing permissions and
// limitations under the License.
//
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarkupMarkType = exports.MarkupNodeType = void 0;
exports.emptyMarkupNode = emptyMarkupNode;
/** @public */
var MarkupNodeType;
(function (MarkupNodeType) {
    MarkupNodeType["doc"] = "doc";
    MarkupNodeType["paragraph"] = "paragraph";
    MarkupNodeType["blockquote"] = "blockquote";
    MarkupNodeType["horizontal_rule"] = "horizontalRule";
    MarkupNodeType["heading"] = "heading";
    MarkupNodeType["code_block"] = "codeBlock";
    MarkupNodeType["text"] = "text";
    MarkupNodeType["image"] = "image";
    MarkupNodeType["file"] = "file";
    MarkupNodeType["reference"] = "reference";
    MarkupNodeType["emoji"] = "emoji";
    MarkupNodeType["hard_break"] = "hardBreak";
    MarkupNodeType["ordered_list"] = "orderedList";
    MarkupNodeType["bullet_list"] = "bulletList";
    MarkupNodeType["list_item"] = "listItem";
    MarkupNodeType["taskList"] = "taskList";
    MarkupNodeType["taskItem"] = "taskItem";
    MarkupNodeType["todoList"] = "todoList";
    MarkupNodeType["todoItem"] = "todoItem";
    MarkupNodeType["subLink"] = "subLink";
    MarkupNodeType["table"] = "table";
    MarkupNodeType["table_row"] = "tableRow";
    MarkupNodeType["table_cell"] = "tableCell";
    MarkupNodeType["table_header"] = "tableHeader";
    MarkupNodeType["mermaid"] = "mermaid";
    MarkupNodeType["comment"] = "comment";
    MarkupNodeType["markdown"] = "markdown";
    MarkupNodeType["embed"] = "embed";
})(MarkupNodeType || (exports.MarkupNodeType = MarkupNodeType = {}));
/** @public */
var MarkupMarkType;
(function (MarkupMarkType) {
    MarkupMarkType["link"] = "link";
    MarkupMarkType["em"] = "italic";
    MarkupMarkType["bold"] = "bold";
    MarkupMarkType["code"] = "code";
    MarkupMarkType["strike"] = "strike";
    MarkupMarkType["underline"] = "underline";
    MarkupMarkType["textColor"] = "textColor";
    MarkupMarkType["textStyle"] = "textStyle";
    MarkupMarkType["highlight"] = "highlight";
})(MarkupMarkType || (exports.MarkupMarkType = MarkupMarkType = {}));
/** @public */
function emptyMarkupNode() {
    return {
        type: MarkupNodeType.doc,
        content: [{ type: MarkupNodeType.paragraph, content: [] }]
    };
}
//# sourceMappingURL=model.js.map